export default "__VITE_ASSET__DM39aiiu__"